import React, {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {adminHttp} from "~/Admin/services/http";
import AdminTranslationForm from "./AdminTranslationForm";

const AdminAddTranslation = ({children, onChange, sections, ...rest}) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const [form, setForm] = useState({});

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        adminHttp
            .post('/translations', form)
            .then(res => {
                setError(null);
                setShow(false);
                setForm({});
                onChange();
            }).catch((error) => {
            setError(error.response?.data);
        });
    };

    return (
        <>
            <button {...rest} onClick={handleShow}>{children}</button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Translation</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving translation!"}
                        </div>
                    )}

                    <AdminTranslationForm values={form} onChange={setForm} sections={sections} errors={error?.errors} />

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Add Translation
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}


export default AdminAddTranslation;
